import { render } from "./DynamoDBView.vue?vue&type=template&id=8ec38318&ts=true"
import script from "./DynamoDBView.vue?vue&type=script&lang=ts"
export * from "./DynamoDBView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__